import React from 'react';
import superagent from 'superagent';
import {Modal, Button} from 'react-bootstrap';

import { LoggedUserAdmin, LoggedUserId } from '../login/Login';

import InfoMsg  from '../../api/InfoMsg';
import LekceEditModal from './LekceEditModal';

import styles from '../kalendar/Home.css';

export default class LekceList extends React.Component {

  constructor() {
    super();
    this.state = {
      datum: new Date(),
      lekce: null,
      actLekce: null,
    };

    this.handleIncMonth = this.handleIncMonth.bind(this);
    this.handleDecMonth = this.handleDecMonth.bind(this);
    this.loadLekce = this.loadLekce.bind(this);
    this.setLekce = this.setLekce.bind(this);
    this.editLekce = this.editLekce.bind(this);
    this.addLekci = this.addLekci.bind(this);
  }

  componentWillMount = () => {
    this.loadLekce();
  }

  loadLekce() {
    var obdobi = this.state.datum.getFullYear() + '-' + ("0" + (this.state.datum.getMonth() + 1)).slice(-2);
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_lekce_list.php?userid=' + LoggedUserId() + '&obdobi=' + obdobi + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({lekce: myObject});
    });
  }

  getLekciProID(id) {
    if (this.state.lekce != null) {
      for (var i = 0; i < this.state.lekce.length; i++) {
        if (this.state.lekce[i].id == id) {
          return this.state.lekce[i];
        }
      }
    }
    return null;
  }

  showEditModal() {
    $('#exampleModalCenter').modal('show');
  }

  editLekce(e) {
    e.preventDefault();
    var lekce = this.getLekciProID(e.target.dataset.id);
    this.setState({ actLekce: lekce}, this.showEditModal);
  }

  addLekci() {
    this.setState({ actLekce: {id: 0, nazev: '', datum: '', cas_od: '', cas_do: '', cena: '', popis: '', lektor: '', kapacita: '', pocet: ''}}, this.showEditModal);
  }

  setLekce(myObject) {
    this.setState({lekce: myObject});
  }

  handleIncMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()+1, 1)
    this.setState({datum: newDate, lekce: null}, this.loadLekce);
  }

  handleDecMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()-1, 1);
    this.setState({datum: newDate, lekce: null}, this.loadLekce);
  }

  render() {
    if (!LoggedUserAdmin) {
      return null;
    }

    var months = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
    var d = this.state.datum;

    if (this.state.lekce == null) {
      return (
        <div className={styles.root}>
          <h1 className={styles.panelHeader}>Seznam lekcí <button type="button" className="btn btn-success float-right mt-2">+</button></h1>
          <div className={"table-responsive " + styles.tablePanel}>
            <h3 className="text-uppercase text-center mb-2">
              <a onClick={this.handleDecMonth} className={"float-left " + styles.pointer}>&lt;</a>
              {months[d.getMonth()] + ' ' + d.getFullYear()}
              <a onClick={this.handleIncMonth} className={"float-right " + styles.pointer}>&gt;</a>
            </h3>
            <div className="text-center"><img src="https://rezervace.copasedeje.cz/servis/images/loading-line.gif" className="loading" /></div>
          </div>
        </div>
      )
    }

    var items = this.state.lekce.map(function(item, index) {
      return (
        <tr key={item.id} className={(item.aktivni == 'A' ? '' : 'lekce_zrusena')}>
          <td className="text-left cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.datum}<div className="d-sm-none d-table-cell poznamka">{item.cas_od}-{item.cas_do}</div></td>
          <td className="text-left d-none d-sm-table-cell cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.cas_od}-{item.cas_do}</td>
          <td className="text-left cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.nazev}</td>
          <td className="text-left d-none d-sm-table-cell cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.lektor}</td>
          <td className="text-center cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.pocet}/{item.kapacita}</td>
          <td className="text-center cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.aktivni}</td>
        </tr>
      )
    }.bind(this));

    return (
      <div className={styles.root}>
        <h1 className={styles.panelHeader}>Seznam lekcí <button type="button" className="btn btn-success float-right mt-2" onClick={this.addLekci}>+</button></h1>
        <div className={"table-responsive shadow " + styles.tablePanel}>
          <h3 className="text-uppercase text-center mb-2">
            <a onClick={this.handleDecMonth} className={"float-left " + styles.pointer}>&lt;</a>
            {months[d.getMonth()] + ' ' + d.getFullYear()}
            <a onClick={this.handleIncMonth} className={"float-right " + styles.pointer}>&gt;</a>
          </h3>
          { this.state.lekce.length > 0 ?
            (
              <table id="table_lekce" className={"table table-striped table-hover"}>
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th className="text-left d-none d-sm-table-cell">Čas</th>
                    <th>Název</th>
                    <th className="d-none d-sm-table-cell">Lektor</th>
                    <th className="text-center">Obsazeno</th>
                    <th className="text-center">Aktivní</th>
                  </tr>
                </thead>
                <tbody>
                  {items}
                </tbody>
              </table>
            ) : ( <div className="my-5 text-center"><i>Nejsou žádné lekce pro tento měsíc</i></div> )
          }
        </div>
        <LekceEditModal lekce={this.state.actLekce} datum={this.state.datum} setLekce={this.setLekce} />
      </div>
    );
  }


}



// WEBPACK FOOTER //
// src/components/lekce/Lekce.js